import gql from "graphql-tag";
import { claimFragment } from "../fragments";

export default {
  upsertMutation: gql`
    mutation m0(
      $id: ID
      $userId: ID!
      $policyId: ID!
      $dependentId: ID
      $claimOwnerId: ID
      $meta: JSONObject!
      $csat: JSONObject
      $status: ClaimStatusEnum
      $type: String
    ) {
      upsertClaim(
        input: {
          id: $id
          userId: $userId
          policyId: $policyId
          dependentId: $dependentId
          claimOwnerId: $claimOwnerId
          meta: $meta
          csat: $csat
          type: $type
          status: $status
        }
      ) {
        claim {
          ...Claim
        }
      }
    }
    ${claimFragment}
  `,
}
